<div class="search-wrapper">
  <i class="fas fa-search"></i>
  <input
    type="text"
    [ngModel]="searchTerm()"
    (ngModelChange)="searchTerm.set($event)"
    placeholder="Search..." />
</div>